module.exports = __webpack_public_path__ + "img/Bank.b5e49af8.svg";